export default {
  animateRows: true,
  suppressColumnVirtualisation: true,
  defaultColDef: {
    sortable: true,
    filter: true,
    resizable: true
  },
  sideBar: {
    toolPanels: [
      {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/gridProps.js